import React from 'react';
import { useLocation } from 'react-router-dom';
import NavbarHome from './NavbarHome';
import NavBarDashboard from './NavBarDashboard';
import { getDecodedToken } from '../services/Token';

const NavbarWrapper = () => {
  const location = useLocation();
  const decoded = getDecodedToken();
  
  // Si está logueado Y está en /dashboard → muestra NavbarDashboard
  // Si está logueado Y NO está en /dashboard → muestra NavbarDashboard (para consistencia)
  // Si NO está logueado → muestra NavbarHome
  
  if (decoded) {
    return <NavBarDashboard />;
  }
  
  return <NavbarHome />;
};

export default NavbarWrapper;
